// src/components/AnnouncementFormModal.js

import React from 'react';
import '../stylings/AnnouncementFormModal.css';

function AnnouncementFormModal({ 
  isOpen, 
  onClose, 
  formData, 
  handleInputChange, 
  handleSubmit, 
  editingId 
}) {
  if (!isOpen) return null;
  
  return (
    <div className="announcement-modal-overlay" onClick={onClose}>
      <div 
        className="announcement-modal-content" 
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>{editingId ? 'Edit Announcement' : 'Create New Announcement'}</h2>
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>
        
        <form className="announcement-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="title">Title *</label>
              <input 
                type="text" 
                id="title" 
                name="title" 
                value={formData.title} 
                onChange={handleInputChange} 
                required 
                maxLength="150"
              />
            </div>
            <div className="form-group">
              <label htmlFor="tag">Category *</label>
              <select 
                id="tag" 
                name="tag" 
                value={formData.tag} 
                onChange={handleInputChange} 
                required
              >
                <option value="Event">Event</option>
                <option value="Update">Update</option>
                <option value="Seasonal">Seasonal</option>
                <option value="Promo">Promotion</option>
                <option value="Alert">Alert</option>
              </select>
            </div>
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="summary">Summary *</label>
              <input 
                type="text" 
                id="summary" 
                name="summary" 
                value={formData.summary} 
                onChange={handleInputChange} 
                required 
                maxLength="255"
              />
            </div>
            <div className="form-group">
              <label htmlFor="image_url">Image URL</label>
              <input 
                type="url" 
                id="image_url" 
                name="image_url" 
                value={formData.image_url} 
                onChange={handleInputChange}
              />
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="body">Full Announcement *</label>
            <textarea 
              id="body" 
              name="body" 
              value={formData.body} 
              onChange={handleInputChange} 
              required 
              rows="4"
            />
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="publish_start">Publish Start Date *</label>
              <input 
                type="datetime-local" 
                id="publish_start" 
                name="publish_start" 
                value={formData.publish_start} 
                onChange={handleInputChange} 
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="publish_end">Publish End Date</label>
              <input 
                type="datetime-local" 
                id="publish_end" 
                name="publish_end" 
                value={formData.publish_end} 
                onChange={handleInputChange}
              />
            </div>
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="status">Status *</label>
              <select 
                id="status" 
                name="status" 
                value={formData.status} 
                onChange={handleInputChange} 
                required
              >
                <option value="draft">Draft</option>
                <option value="pending">Pending Approval</option>
                <option value="approved">Approved</option>
                <option value="scheduled">Scheduled</option>
                <option value="archived">Archived</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="priority">Priority * (1 = Highest)</label>
              <input 
                type="number" 
                id="priority" 
                name="priority" 
                value={formData.priority} 
                onChange={handleInputChange} 
                min="1" 
                max="10" 
                required
              />
            </div>
          </div>
          
          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="submit-btn">
              {editingId ? 'Update Announcement' : 'Create Announcement'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AnnouncementFormModal;